var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"visible":_vm.isShow,"title":"备注","ok-text":"确认","cancel-text":"取消"},on:{"ok":_vm.ok,"cancel":_vm.cancel}},[_c('a-textarea',{attrs:{"placeholder":"添加备忘录信息，仅自己可见"},model:{value:(_vm.computedRemark),callback:function ($$v) {_vm.computedRemark=$$v},expression:"computedRemark"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab89142","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/deal/orders/RemarkModal.vue
// module id = null
// module chunks = 